import { O, pipe } from '@mobily/ts-belt'

import type { Comment, StoreDiet } from '@/types/Diet'

import type { DietCommentGridItem } from './types'

const validComment = (comment?: Comment | null) =>
  pipe(
    O.fromNullable(comment),
    O.filter(value => value.title !== '' || value.content !== ''),
    O.toUndefined,
  )

export const buildCommentViewModels = (diet: StoreDiet | undefined, daysCount: number) => {
  const list: DietCommentGridItem[][] = []
  const meals = diet?.data.meals ?? []

  for (let dayIndex = 0; dayIndex < daysCount; dayIndex++) {
    const items: DietCommentGridItem[] = []
    for (let mealIndex = 0; mealIndex < meals.length; mealIndex++) {
      const meal = meals[mealIndex]
      const mealDay = meal?.days[dayIndex]
      let commentIndex = 0

      if (mealIndex === 0) {
        items.push({
          comment: validComment(mealDay?.comments[commentIndex]),
          commentIndex,
          dayIndex,
          mealIndex,
          type: 'comment',
        })
        commentIndex = 1
      }

      items.push({
        meal: {
          dishesAndIngredients: (mealDay?.dishes_and_ingredients ?? []).map(
            item => item.name || '',
          ),
          hour: mealDay?.hour ?? '',
          name: meal?.name ?? '',
        },
        type: 'meal',
      })
      items.push({
        comment: validComment(mealDay?.comments[commentIndex]),
        commentIndex,
        dayIndex,
        mealIndex,
        type: 'comment',
      })
    }
    list.push(items)
  }

  return list
}
